import { StyleSheet } from 'react-native'

import { DS } from '../../design-system'
import { GradientButton } from '../GradientButton/GradientButton'

interface DeleteResponseProps {
  onCancel: () => void
  onDelete: () => void
}

export const DeleteResponse = (props: DeleteResponseProps) => {
  const { onCancel, onDelete } = props
  return (
    <DS.Frame bg="Brand/Cream" style={startStyle.deleteContainer}>
      <DS.Frame justifyContent="center" alignItems="center">
        <DS.Icon name="Trash" size={48} />
      </DS.Frame>
      <DS.Text variant="Heading 3/Medium" textAlign="center" style={{ marginVertical: 8 }}>
        Are you sure?
      </DS.Text>
      <DS.Text variant="Body Large/Regular" textAlign="center">
        Your response will be removed permanently.
      </DS.Text>
      <DS.Frame key={'delete-action-frame'} row gap="4" style={{ marginVertical: 16 }}>
        <DS.Button
          variant={'Large/Primary'}
          type={'On Dark'}
          backgroundColor={'Brand/Cream'}
          borderColor={'Brand/Light Grey'}
          style={{ width: '50%' }}
          onPress={onDelete}
        >
          <DS.Text variant="Body Medium/Medium" color="Global/Black" textAlign="center">
            Yes, delete
          </DS.Text>
        </DS.Button>
        <GradientButton title="No, keep it" onPress={onCancel} contentContainerStyle={{ width: '50%' }} />
      </DS.Frame>
    </DS.Frame>
  )
}

const startStyle = StyleSheet.create({
  deleteContainer: {
    width: '100%',
    padding: 16,
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12
  }
})
